import { XMLParser } from "fast-xml-parser";
const parser = new XMLParser({ removeNSPrefix: true });
export function parseSampleXml(content) {
    const doc = parser.parse(content);
    const record = findFirstRecord(doc);
    if (!record)
        throw new Error("no repeating record element found in sample XML");
    return Object.keys(record).map((name, i) => ({
        name,
        order: i + 1,
        type: "raw",
        required: false,
    }));
}
/**
 * Infer an ExportFormatStructureNode[] slot tree from a sample XML document.
 *
 * Algorithm (per element):
 * - A tag appearing more than once among siblings → "collection" (children = structure of first occurrence).
 * - A child element that itself has child elements → "group".
 * - A text-only leaf → "field" with heuristic dataType:
 *     number (JS numeric after parsing), date (ISO YYYY-MM-DD string), else text.
 *
 * The document root is the single top-level node (type "group" or "collection").
 * Because a concrete XML document is a finite tree there are no cycles, so no
 * cycle guard is required.
 */
export function parseSampleXmlToStructure(content) {
    const doc = parser.parse(content);
    const rootKeys = Object.keys(doc);
    return rootKeys.map((key) => structureNode(key, doc[key]));
}
const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
function inferDataType(value) {
    if (typeof value === "number")
        return "number";
    if (typeof value === "string" && ISO_DATE_RE.test(value.trim()))
        return "date";
    return "text";
}
function structureNode(name, value) {
    // Array → collection (repeating element)
    if (Array.isArray(value)) {
        const firstChild = value[0];
        const children = firstChild != null && typeof firstChild === "object" && !Array.isArray(firstChild)
            ? structureChildren(firstChild)
            : [];
        return { name, type: "collection", cardinality: { min: 0 }, children };
    }
    // Object → group (element with element children)
    if (value != null && typeof value === "object") {
        const children = structureChildren(value);
        return { name, type: "group", children };
    }
    // Scalar leaf → field
    const dataType = inferDataType(value);
    return { name, type: "field", dataType, required: false, allowEmpty: true };
}
function structureChildren(obj) {
    return Object.entries(obj).map(([key, val]) => structureNode(key, val));
}
// Walk to the first object that has at least one scalar child (the record).
function findFirstRecord(node) {
    if (node == null || typeof node !== "object")
        return null;
    for (const v of Object.values(node)) {
        const candidate = Array.isArray(v) ? v[0] : v;
        if (candidate &&
            typeof candidate === "object" &&
            Object.values(candidate).some((x) => typeof x !== "object")) {
            return candidate;
        }
        const deeper = findFirstRecord(v);
        if (deeper)
            return deeper;
    }
    return null;
}
//# sourceMappingURL=sample-xml.js.map